<template>
  <div class="question-clone-modal">
    <div class="modal-card">
      <div class="modal-card-body">
        <v-select
          :close-on-select="true"
          :filterable="false"
          label="id"
          :options="options"
          placeholder="Search and select"
          @input="inputHandler"
          @search="searchQuestionsHandler"
        >
          <template slot="no-options">
            <div class="content select-hint">
              <span v-if="query">
                No matching results
              </span>
              <span v-else>
                Type to search questions...
              </span>
            </div>
          </template>
          <template slot="option" slot-scope="option">
            <div class="content option">
              <div class="is-size-6">
                {{ option.statement }}
              </div>
              <div class="is-size-7 subtitle">
                {{ option.correctStatement }}
              </div>
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="content option">
              <div class="is-size-6">
                {{ option.statement }}
              </div>
              <div class="is-size-7 subtitle">
                {{ option.correctStatement }}
              </div>
            </div>
          </template>
        </v-select>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';

export function openQuestionSearchModal(parent, props) {
  return new Promise((resolve, reject) => {
    parent.$buefy.modal.open({
      parent,
      component: QuestionSearchModal,
      hasModalCard: true,
      events: {
        input: resolve
      },
      props,
      fullScreen: true,
      onCancel: reject
    });
  });
}

const QuestionSearchModal = {
  data: function() {
    return {
      options: [],
      query: ''
    };
  },
  methods: {
    inputHandler(event) {
      this.$emit('input', event);
      this.$emit('close');
    },
    searchQuestionsHandler(search, loading) {
      loading(true);
      this.searchQuestions(search, loading);
    },
    searchQuestions: debounce(function(search, loading) {
      this.query = search;
      const index = this.$searchClient.initIndex('questions');
      index.search(
        {
          query: search,
          hitsPerPage: 8
        },
        (error, data) => {
          if (error) {
            this.$buefy.toast.open({
              message: 'Failed to search for questions!',
              type: 'is-danger'
            });
          } else {
            let results = data.hits.map(hit => ({
              id: hit.objectID,
              statement: hit.statement,
              correctStatement: hit.correctStatement
            }));
            this.options = results;
          }
          loading(false);
        }
      );
    }, 400)
  }
};

export default QuestionSearchModal;
</script>

<style lang="scss" scoped>
.question-clone-modal {
  margin-top: 5rem;
  .modal-card {
    margin: auto;
    .modal-card-body {
      height: 40rem;
      background-color: transparent;
    }
  }
}
</style>
